export default {   
    addresses: function(postcode) {
        let params = {
            postcode: postcode
        };
        return window.axios.get(`postcodeLookup`, {params: params});
    },

    get: function(addressId) {
        return window.axios.get(`postcodeLookup/${addressId}`);
    }
}